// AUTO-GENERATED — prepisuje ga scripts/set-version.js prije svakog builda.
// Ne editiraj ručno.
export const APP_VERSION = '1.0.0';
export const APP_COMMIT = '5c3ac17';
export const BUILD_DATE = '2026-08-04';
